import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoSeguimientoTelas() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS_TELAS = `${process.env.REACT_APP_URL_INVENTARIOS_TELAS}`;
  const URL_SEGUIMIENTOS = `${process.env.REACT_APP_URL_SEGUIMIENTOS}`;
  const URL_TIPOS_TELAS = process.env.REACT_APP_URL_TIPOS_TELAS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const [inventariosTelas, setInventariosTelas] = useState([]);
    const [colores, setColores] = useState([]);
    const [selectedColor, setSelectedColor] = useState("");
    const [destinos, setDestinos] = useState([]);
    const [selectedDestino, setSelectedDestino] = useState("");
  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [nombreArticulo, setNombreArticulo] = useState("");



  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalMailRollo, setModalMailRollo] = useState(false);
  const toggleMailRollo = () => setModalMailRollo(!modalMailRollo);

  const [idColoresInventarioTelas, setIdColoresInventarioTelas] = useState("");
  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [modalDesgloce, setModalDesgloce] = useState(false);
  const toggleDesgloce = () => setModalDesgloce(!modalDesgloce);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const [movimientos, setMovimientos] = useState([]);

  useEffect(() => {
    axios
      .get(URL_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
      // axios
      //   .get(URL_COLORES, {
      //     headers: {
      //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //     },
      //   })
      //   .then((response) => {
      //     let allColores = response.data;
      //     setColores(allColores);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
  }, []);

  function BuscaArticulo(event) {
  const idArticulo = event.target.value;
  setSelectedArticulo(idArticulo);

  // Buscar el artículo en el array original
  const articuloSeleccionado = articulos.find((a) => a._id === idArticulo);
  if (articuloSeleccionado) {
    const nombreFormateado = `${articuloSeleccionado.nombre} / ${articuloSeleccionado.tiposTelas[0]?.name || ""}`;
    setNombreArticulo(nombreFormateado);
  }
    // Jala Movimientos
   axios
    .get(`${URL_SEGUIMIENTOS}/${event.target.value}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allMovs = response.data;

      // Guardar movimientos completos
      setComments(allMovs);
      setMovimientos(allMovs);

      // Colores únicos (solo si tienen color definido)
      const colores = [
        ...new Set(
          allMovs
            .filter((a) => a.color && a.color.trim() !== "")
            .map((a) => a.color.trim())
        ),
      ];
      setColores(colores);

      // Destinos únicos (solo si tienen destino definido)
      const destinos = [
        ...new Set(
          allMovs
            .filter((a) => a.destino && a.destino.trim() !== "")
            .map((a) => a.destino.trim())
        ),
      ];
      setDestinos(destinos);
    })
    .catch((err) => {
      console.log(err);
    });
  }

  const ListaInventariosTelas = comments.sort((a, b) =>
    a.codigo > b.codigo ? 1 : -1
  );

  function PDFTabla() {
    const data = comments
      // .filter(
      //   (comment) =>
      //     comment.destino.toLowerCase().includes(search.toLowerCase()) ||
      //     comment.color.toLowerCase().includes(search.toLowerCase()) ||
      //     comment.tipoMov.toLowerCase().includes(search.toLowerCase())
      // )
      // .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
      .map((a) => {
        if (
          (selectedColor === "" ||
            selectedColor.trim() === (a.color || "").trim()) &&
          (selectedDestino === "" ||
            selectedDestino.trim() === (a.destino || "").trim())
        ) {
          return [
            a.fecha,
            a.tipoMov,
            a.numMov,
            a.destino,
            a.color,
            new Intl.NumberFormat("en-US").format(a.cantidad),
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 60, 25);
    doc.text(`Seguimiento Tela ${nombreArticulo}`, 15, 42);
    doc.autoTable({
      head: [
        ["Fecha", "Movimiento", "Numero", "Cliente/Prov", "Color", "Cantidad"],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [["", "", "", "", "", ""]],
      showFoot: "lastPage",
    });
    // doc.save(`Seguimiento.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments
      .filter(
        (comment) =>
          comment.destino.toLowerCase().includes(search.toLowerCase()) ||
          comment.color.toLowerCase().includes(search.toLowerCase()) ||
          comment.tipoMov.toLowerCase().includes(search.toLowerCase())
      )
      .map((a) => {
        if (
          (selectedColor === "" ||
            selectedColor.trim() === (a.color || "").trim()) &&
          (selectedDestino === "" ||
            selectedDestino.trim() === (a.destino || "").trim())
        ) {
          return {
            Fecha: a.fecha,
            Movimiento: a.tipoMov,
            Numero: a.numMov,
            Destino: a.destino,
            Color: a.color,
            Cantidad: a.cantidad,
          };
        }
      });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoSeguimientoTelas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoSeguimientoTelas",
        sheetFilter: [
          "Fecha",
          "Movimiento",
          "Numero",
          "Destino",
          "Color",
          "Cantidad",
        ],
        sheetHeader: [
          "Fecha",
          "Movimiento",
          "Numero",
          "Destino",
          "Color",
          "Cantidad",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments
      // .filter(
      //   (comment) =>
      //     comment.destino.toLowerCase().includes(search.toLowerCase()) ||
      //     comment.color.toLowerCase().includes(search.toLowerCase()) ||
      //     comment.tipoMov.toLowerCase().includes(search.toLowerCase())
      // )
      // .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
      .map((a) => {
        if (
          (selectedColor === "" ||
            selectedColor.trim() === (a.color || "").trim()) &&
          (selectedDestino === "" ||
            selectedDestino.trim() === (a.destino || "").trim())
        ) {
          return [
            a.fecha,
            a.tipoMov,
            a.numMov,
            a.destino,
            a.color,
            new Intl.NumberFormat("en-US").format(a.cantidad),
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 60, 25);
    doc.text(`Seguimiento Tela ${nombreArticulo}`, 15, 42);
    doc.autoTable({
      head: [
        ["Fecha", "Movimiento", "Numero", "Cliente/Prov", "Color", "Cantidad"],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [["", "", "", "", "", ""]],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Seguimiento",
          email: mailTo,
          fileName: "ListadoSeguimientoTelas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Disponibles.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Movimiento", field: "tipoMov", sortable: true },
    { name: "Numero", field: "numMov", sortable: false },
    { name: "Cliente / Proveedor", field: "destino", sortable: true },
    { name: "Color", field: "color", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.destino.toLowerCase().includes(search.toLowerCase()) ||
          comment.color.toLowerCase().includes(search.toLowerCase()) ||
          comment.tipoMov.toLowerCase().includes(search.toLowerCase())
      );
    }
    if (selectedColor) {
      computedComments = computedComments.filter((e) =>
        e.color.includes(selectedColor)
      );
    }

    if (selectedDestino) {
      computedComments = computedComments.filter((e) =>
        e.destino.includes(selectedDestino)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, selectedColor, selectedDestino]);

  let totalDisponible = 0;
  let totalPedido = 0;
  let totalInventarioTelas = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_telas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuCatalogos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Disponible</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Seguimiento Telas</h3>
          <div className="row">
            {/* <div className="col-md-2">
              <Label>Color</Label>
            </div> */}
          </div>
          <div className="row">
            <Col md={2}>
            <Label>Articulo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedArticulo}
                onChange={(e) => {
                  BuscaArticulo(e);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {articulos
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} / {a.tiposTelas[0].name}{" "}
                      </option>
                    );
                  })}
              </Input>
            </Col>
            <Col md={2}>
            <Label>Color</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedColor}
                onChange={(e) => {
                  setSelectedColor(e.target.value);
                }}
                disabled={colores.length === 0}
              >
                <option value="">Selecciona</option>
                {colores
                  .sort((a, b) => (a > b ? 1 : -1))
                  .map((a) => {
                    return <option value={a}>{a}</option>;
                  })}
              </Input>
            </Col>
             <Col md={2}>
            <Label>Destino</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedDestino}
                onChange={(e) => {
                  setSelectedDestino(e.target.value);
                }}
                disabled={destinos.length === 0}
              >
                <option value="">Selecciona</option>
                {destinos
                  .sort((a, b) => (a > b ? 1 : -1))
                  .map((a) => {
                    return <option value={a}>{a}</option>;
                  })}
              </Input>
            </Col>

            <div className="col-md-6 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <br />

        

          {/* Tabla Movimientos */}
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />

          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />

            <tbody>
              {commentsData
                .sort((a, b) => (a.fecha > b.fecha ? 1 : -1))
                .map((a) => {
                  return (
                    <tr>
                      <td>{a.fecha}</td>
                      <td>{a.tipoMov}</td>
                      <td>{a.numMov}</td>
                      <td>{a.destino}</td>
                      <td>{a.color}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.cantidad)}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}

      {loader}
    </>
  );
}

export default ListadoSeguimientoTelas;
